import { Spinner } from '@fluentui/react-components';
import { FC } from 'react';
import { useSharedClasses } from 'shared/styles';

interface ILoadingProps {
    text: string;
}

export const Loading: FC<ILoadingProps> = ({ text }) => {
    const classes = useSharedClasses();
    return (
        <div className={classes.informativeView}>
            <Spinner labelPosition="below" label={text} />
        </div>
    );
};
